/**
 * EssenceBaseComponent mínimo — suporte a swiper-slider e Web Components TeamDrop.
 */
class EssenceBaseComponent extends HTMLElement {
  get eagerInit() { return false; }
  get observerRootMargin() { return "0px 0px -15% 0px"; }
  get observerThreshold() { return 0; }

  connectedCallback() {
    if (this.__tdConnected) return;
    this.__tdConnected = true;

    this.__tdController = new AbortController();
    const signal = this.__tdController.signal;

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener(
        "shopify:block:select",
        (event) => {
          if (event.target && this.contains(event.target)) {
            this.onEditorBlockSelect?.(event);
          }
        },
        { signal }
      );

      document.addEventListener(
        "shopify:block:deselect",
        (event) => {
          if (event.target && this.contains(event.target)) {
            this.onEditorBlockDeselect?.(event);
          }
        },
        { signal }
      );

      document.addEventListener(
        "shopify:section:unload",
        (event) => {
          if (event.target && event.target.contains(this)) {
            this.onEditorSectionUnload?.(event);
          }
        },
        { signal }
      );
    }

    var isEager = this.hasAttribute("data-eager") || this.eagerInit === true;
    if (isEager || !("IntersectionObserver" in window)) {
      this.initOnce();
    } else {
      this.__tdObserver = new IntersectionObserver(
        (entries) => {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.initOnce();
              if (this.__tdObserver) {
                this.__tdObserver.disconnect();
                this.__tdObserver = null;
              }
              break;
            }
          }
        },
        {
          rootMargin: this.observerRootMargin,
          threshold: this.observerThreshold,
        }
      );
      this.__tdObserver.observe(this);
    }
  }

  initOnce() {
    if (this.__tdInitialized) return;
    this.__tdInitialized = true;
    this.init();
  }

  init() {}

  disconnectedCallback() {
    this.destroy?.();
    if (this.__tdObserver) {
      this.__tdObserver.disconnect();
      this.__tdObserver = null;
    }
    if (this.__tdController) {
      this.__tdController.abort();
      this.__tdController = null;
    }
    this.__tdConnected = false;
    this.__tdInitialized = false;
  }
}

window.EssenceBaseComponent = EssenceBaseComponent;
